
export const marketingItems = [
  { name: "How It Works", path: "#how-it-works" },
  { name: "Features", path: "#dashboard-feature" },  // Updated to point to dashboard-feature
  { name: "Pricing", path: "#pricing" },
  { name: "FAQ", path: "#faq" },
  { name: "Rewards", path: "#rewards" },
];

export const dashboardItems = [
  { name: "Dashboard", path: "/dashboard" },
  { name: "Investor Forms", path: "/forms" }, 
  { name: "Investor Leads", path: "/leads" },
  { name: "Campaigns", path: "/campaigns" },
  { name: "Compliance", path: "/compliance-vault" },
  { name: "Raise Capital", path: "/raise-capital" },
  { name: "Admin", path: "/admin" },
  { name: "Settings", path: "/settings" },
  { name: "Earn Rewards", path: "/earn-rewards" },
];
